import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {AbsoluteValueView} from '@app/modules/svg/element/complex/cartesian/graphic/AbsoluteValueView';

export class DrawAbsoluteValue extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new AbsoluteValueView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.ABSOLUTE_VALUE_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.ABSOLUTE_VALUE_TOOL_OFF);
    }
  }

  public _new(): DrawAbsoluteValue {
    return new DrawAbsoluteValue(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.ABSOLUTE_VALUE;
  }
}
